import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { updateBankAccount } from "./index.js";

export default function useUpdateBankAccount() {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ bankAccountId, displayString }) =>
      updateBankAccount(ctx, bankAccountId, {
        display_string: displayString,
      }),
    onSuccess: () => {
      // since a bank account is updated, fetching bank account should not be from cache
      queryClient.invalidateQueries({ queryKey: ["transaction-methods"] });
    },
  });
}
